import type { GameRecord } from '@pixel-archive/shared';
import { gameBelongsToPlatform, type CompatiblePlatform } from './compatibility';

export type RediscoverGame = GameRecord & {
  compatiblePlatforms: string | null;
  category?: string | null;
};
export type RediscoverCollection = { games: RediscoverGame[]; machines: CompatiblePlatform[] };

export function eligibleGames(
  games: RediscoverGame[],
  machine?: CompatiblePlatform,
): RediscoverGame[] {
  const unique = new Map<string, RediscoverGame>();
  for (const game of games) {
    if (game.status !== 'owned') continue;
    if (
      machine &&
      !gameBelongsToPlatform(
        {
          platform_id: game.platformId,
          compatible_platforms: game.compatiblePlatforms,
        },
        machine,
      )
    )
      continue;
    if (!unique.has(game.id)) unique.set(game.id, game);
  }
  return [...unique.values()];
}

// Pure function: neither published records nor the previous cycle are modified.
export function drawGame(games: RediscoverGame[], seen: readonly string[], random = Math.random) {
  const eligible = eligibleGames(games);
  let cycle = seen.filter((id) => eligible.some((game) => game.id === id));
  let available = eligible.filter((game) => !cycle.includes(game.id));
  if (!available.length) {
    cycle = [];
    available = eligible;
  }
  if (!available.length) return { game: null, seen: [] as string[] };
  const game = available[Math.floor(random() * available.length)];
  return { game, seen: [...cycle, game.id] };
}
